<template>
  <div>
     <div
          dir="ltr"
          class="flex items-center rounded-full bg-[#1a1c24] p-1 text-xs font-medium"
        >
          <button
            type="button"
            @click="setLanguage('en')"
            :class="[
              'rounded-full px-3 py-1.5 transition',
              currentLanguage === 'en'
                ? 'bg-[#d0b45e] font-bold text-[#17181d]'
                : 'text-gray-400 hover:text-white',
            ]"
          >
            Eng
          </button>

          <button
            type="button"
            @click="setLanguage('ar')"
            :class="[
              'rounded-full px-3 py-1.5 transition',
              currentLanguage === 'ar'
                ? 'bg-[#d0b45e] font-bold text-[#17181d]'
                : 'text-gray-400 hover:text-white',
            ]"
          >
            عربي
          </button>
        </div>
  </div>
</template>

<script >
export default {
  props: {
    currentLanguage: {
      type: String,
      required: true,
    },
  },
  emits: ['language-changed'],
  methods: {
    setLanguage(language) {
      this.$emit('language-changed', language);
    },
  },
};
</script>

<style>

</style>